<template>
  <v-navigation-drawer class="content" v-model="help" right fixed temporary>
    <v-container class="mt-12" fluid>
      <v-row align="center" justify="center">
        <v-icon class="mb-3" color="#575B64" large>fa-life-ring</v-icon>
      </v-row>
      <v-row align="center" justify="center">
        <div>
          <h2 class="text-center">{{ $t('title') }}</h2>
          <p style="color: #3E3E3E" class="text-center">{{ $t('description') }}</p>
        </div>
      </v-row>
      <v-row class="mt-7" align="center" justify="center">
        <v-list style="height: 100%;">
          <v-list-item style="width: 100%" v-for="item in items" :key="item.title">
            <v-btn width="100%" @click="goToLink(item.link)" large outlined>
              {{ item.title }}
              <v-icon class="ml-2" :color="(item.pro)? 'primary' : 'secondary'" small>{{ item.icon }}</v-icon>
            </v-btn>
          </v-list-item>
        </v-list>
      </v-row>
    </v-container>
    <template v-slot:append>
      <v-container>
        <v-row class="pa-7" align="center" justify="center">
          <v-btn class="button-close" @click="close">{{ $t('btnClose') }}</v-btn>
        </v-row>
      </v-container>
    </template>
  </v-navigation-drawer>
</template>

<script>
export default {
  name: "HelpDesk",
  props: {
    help: Boolean,
  },
  data() {
    return {
      items: [],
    };
  },
  watch: {
    '$i18n.locale': function () {
      this.getItems();
    },
  },
  mounted() {
    this.getItems();
  },
  methods: {
    getItems() {
      this.items = [
        { title: this.$t('items.videoGuides'), icon: 'fa-play-circle', link: `https://youtube.com/playlist?list=${(this.$i18n.locale === 'en')? 'PL2PkIkKhTVujMB1wUsUGPZ0uXNAu7a-n7' : 'PL2PkIkKhTVujKyscw4gOKjWtMzoaMZjOD'}`, pro: false, },
        { title: this.$t('items.automatePlatform'), icon: 'fa-plug', link: `https://swiset.com/${(this.$i18n.locale === 'en')? 'automated-journal' : 'es/journal-automatico'}`, pro: false, },
        { title: this.$t('items.moreFAQs'), icon: 'fa-info-circle', link: 'https://swiset.freshdesk.com', pro: false, },
        { title: this.$t('items.supportTicket'), icon: 'fa-question-circle', link: 'https://swiset.freshdesk.com/support/tickets/new', pro: false, },
      ];
      if(!this.$store.state.user.isPro)
        this.items.unshift({ title: this.$t('items.proBenefits'), icon: 'fa-star', link: 'https://swiset.com/why-swiset-pro', pro: true, });
    },
    goToLink(link) {
      window.open(link);
    },
    close() {
      this.$emit('close');
    },
  },
}
</script>

<i18n>
{
  "en": {
    "title": "Quick Support",
    "description": "Self service help options",
    "items": {
      "proBenefits": "Pro Benefits",
      "videoGuides": "Video Guides",
      "automatePlatform": "Automate Platform",
      "moreFAQs": "More FAQs",
      "supportTicket": "Support Ticket"
    },
    "btnClose": "Close"
  },
  "es": {
    "title": "Soporte Rápido",
    "description": "Opciones de autoayuda",
    "items": {
      "proBenefits": "Beneficios del Pro",
      "videoGuides": "Guías en Video",
      "automatePlatform": "Automatiza tú Platforma",
      "moreFAQs": "Más FAQs",
      "supportTicket": "Ticket de Soporte"
    },
    "btnClose": "Cerrar"
  }
}
</i18n>

<style scoped>
.content {
  height: 100vh;
  min-width: 17vw;
  z-index: 9999999 !important;
  background-color: rgba(256, 256, 256, 0.91) !important;
  backdrop-filter: blur(5px) !important;
}

.button-close {
  width: 77%;
  background-color: #111111 !important;
  color: #ffffff !important;
  border: #111111 solid 1px;
}
</style>
